// React
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

class DialogList extends React.PureComponent {

    static propTypes = {
        classes: PropTypes.object,
        close: PropTypes.func,
        dataArray: PropTypes.array,
        fullScreen: PropTypes.bool,
        open: PropTypes.bool,
        title: PropTypes.string
    };

    render() {
        const { fullScreen, dataArray, open, close, title, classes } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
                <DialogContent> {
                    dataArray && dataArray.map((cell, index) => <div key={index} className={classes.cell}>{cell}</div>)}
                </DialogContent>
                <DialogActions>
                    <IconButton color='secondary' onClick={close}>
                        <ClearIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    cell: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    text: {
        fontFamily: 'roboto'
    }
});

export default withStyles(styles)(DialogList);
